import 'styles/Loading.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import Loading from 'react-loading'

class Spinner extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    const { size } = this.props
    let circleSize = size || 24
    return <div className='spinner-component'><Loading type='bubbles' color='#ef6b5e' /></div>
  }
  componentWillReceiveProps(nextProps) {
  }
}
//
Spinner.contextTypes = {
  router: React.PropTypes.object.isRequired
}
Spinner.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(Spinner)



// WEBPACK FOOTER //
// ./src/components/Utils/Spinner.js